import { atom } from "jotai";
import { ApiUserMinimal } from "src/api/types";
import useApi, { emptyApiState } from "src/hooks/api/utils/useApi";

const stateAtom: any = atom(emptyApiState);

type Options = {
	filter?: any;
};

function useConnections(options?: Options) {
	const { state, actions, api } = useApi(stateAtom, {
		baseUrl: `/connections`,
		query: {
			limit: 20,
			response_type: "avatar",
			...(options?.filter || {}),
		},
	});
	const connections: ApiUserMinimal[] = state?.list || [];

	const search = (search: string) => {
		actions.list({ q: search });
	};

	return {
		connections,
		search: state.filter.q,
		status: state.status,
		actions: {
			...actions,
			search,
		},
		api,
	};
}

export default useConnections;
